"use client";

import Image from "next/image";

export type IPhoneMockupProps = {
  src: string;
  alt: string;
  priority?: boolean;
  className?: string;
  sizes?: string;
};

/** Intrinsic dimensions for responsive scaling; aspect preserved so screenshot is never cropped. */
const SCREEN_WIDTH = 390;
const SCREEN_HEIGHT = 844;

/**
 * iPhone-style frame. Screenshot always displays fully (object-fit: contain, width 100%, height auto).
 * Thin top hardware strip; frame height adapts to screenshot. Bottom tab bar never clipped.
 */
export function IPhoneMockup({
  src,
  alt,
  priority = false,
  className = "",
  sizes = "(min-width: 1024px) 340px, (min-width: 640px) 280px, 240px",
}: IPhoneMockupProps) {
  return (
    <div className={`relative flex justify-center items-center ${className}`}>
      <div className="relative w-full max-w-[280px] sm:max-w-[320px] lg:max-w-[340px]">
        <div className="relative rounded-[2.75rem] border-[8px] border-slate-800 bg-slate-900 shadow-2xl shadow-black/50 overflow-hidden flex flex-col">
          {/* Thin top bezel — minimal dead space */}
          <div className="flex-shrink-0 h-4 flex items-center justify-center bg-black">
            <div className="w-12 h-3 rounded-full bg-slate-800" aria-hidden />
          </div>
          {/* Screenshot: full width, height auto — never cropped, frame adapts to image */}
          <div className="w-full bg-black">
            <Image
              src={src}
              alt={alt}
              width={SCREEN_WIDTH}
              height={SCREEN_HEIGHT}
              sizes={sizes}
              className="w-full h-auto object-contain object-center"
              priority={priority}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
